import CustomModal from "../CustomModal";
import DeleteModalIcon from "../../assets/svg/DeleteModalIcon.svg";
import { Button } from "antd";
import Lottie from "lottie-react";
import trashAnimation from "../../assets/animations/trash-animation.json"; // adjust path if needed
import { useTranslation } from "react-i18next";

const DeleteFilesDialog = ({ visible, onCancel, onDelete }) => {
  const { t } = useTranslation();
  return (
    <CustomModal
      title=""
      visible={visible}
      handleOk={onDelete}
      handleCancel={onCancel}
      cancelBtnText="Cancel"
      okBtnText="Delete"
      width={400}
      className="my-custom-modal"
      footer={false}
    >
      <div className="delete-dialog-content">
        <div className="dialog-header">
          <div style={{ width: 200, height: 200 }}>
            <Lottie animationData={trashAnimation} loop={true} />
          </div>
        </div>

        <div className="dialog-text">
          <h2 className="dialog-title">
            {t("common.delete")} {t("label.files")}
          </h2>
          <p className="dialog-message">{t("messages.confirmDelete")}</p>
        </div>
      </div>

      <div className="figma-modal-footer">
        <Button onClick={onCancel} className="figma-cancel-btn">
          {t("common.cancel")}
        </Button>

        <Button type="primary" onClick={onDelete} className="figma-delete-btn">
          {t("common.delete")}
        </Button>
      </div>
    </CustomModal>
  );
};

export default DeleteFilesDialog;
